import { UserRound } from "lucide-react";
import { useAuth } from "@/core/auth/hooks/useAuth";
import { DetailSummary } from "@/shared/components/ui/DetailSummary";
import { EmptyState } from "@/shared/components/ui/EmptyState";
import { ErrorState } from "@/shared/components/ui/ErrorState";
import { LoadingSpinner } from "@/shared/components/ui/LoadingSpinner";
import { SectionCard } from "@/shared/components/ui/SectionCard";
import { useCurrentProfile } from "../hooks/useCurrentProfile";

export function ProfileDetails() {
  const { user } = useAuth();
  const { profile, isLoading, error, refetch } = useCurrentProfile();
  if (!user) return null;
  const name = profile?.displayName
    || [profile?.firstName, profile?.lastName].filter(Boolean).join(" ")
    || "Not specified";

  return (
    <SectionCard title="Logged-in user" icon={<UserRound />} description="Your Froppio account.">
      <DetailSummary items={[
        { label: "Email", value: user.email || "Not specified" },
        { label: "User ID", value: user.id },
      ]} />
      {isLoading ? <LoadingSpinner message="Loading your profile..." />
        : error ? <ErrorState message={error.message} onRetry={() => void refetch()} />
        : profile ? <DetailSummary items={[{ label: "Name", value: name }]} />
        : <EmptyState message="No profile has been set up for this account." />}
    </SectionCard>
  );
}
